import cn from 'classnames';
import Chip from '@packages/shared/core/common/components/common/Chip';
import styles from './ChatFooterIceBreakingTipsMobile.module.scss';

type ChatFooterIceBreakingTipsMobileProps = {
  className?: string;
  onSelectTip: (tip: string) => void;
  tips: Array<string>;
  selectedTip?: string;
};

const ChatFooterIceBreakingTipsMobile = ({
  className,
  onSelectTip,
  tips,
  selectedTip,
}: ChatFooterIceBreakingTipsMobileProps) => {
  return (
    <div className={cn(styles.root, className)}>
      <ul className={styles.tipsList}>
        {tips.map((tip, index) => (
          <li className={styles.tipsListItem} key={index}>
            <Chip
              className={styles.tip}
              labelProps={{ className: styles.tipLabel }}
              variant={tip === selectedTip ? 'primary' : 'primary-outlined'}
              onClick={() => onSelectTip(tip)}
            >
              {tip}
            </Chip>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ChatFooterIceBreakingTipsMobile;
